export default function NotFound() {
  return (
    <div>
      404 - Pagina no encontrada
    </div>
  )
}